import { RiCollageFill, RiMedal2Fill } from "react-icons/ri";

import ColecaoDeCartasDoAluno from "./ColecaoDeCartasDoAluno";
import Medalhas from "./Medalhas";

/**
 * O REGISTRO DOS TIPOS DE CONQUISTA — a lista que a página de conquistas percorre.
 *
 * É o ponto de extensão: acrescentar um tipo (troféu de turma, selo de projeto,
 * ranking) é uma entrada aqui mais um componente de conteúdo. Nada em `index.js`
 * muda, e o layout já vem pronto — cabeçalho, contador e recolher são de
 * `SecaoDeConquista`.
 *
 * O CONTRATO DE UM CONTEÚDO, e é curto de propósito:
 *
 *   props recebidas   `token` (a sessão) e `onResumo`
 *   `onResumo`        chamado com `{ conquistadas, total }` quando o conteúdo sabe
 *                     seus números, para o cabeçalho poder mostrá-los. Não chamar é
 *                     válido: a seção fica sem contador
 *   pode devolver     `null`, e a página some com a seção inteira (é o que a coleção
 *                     faz quando a rota da trilha não está publicada no ambiente)
 *
 * A ORDEM AQUI É A DA TELA, e ela é uma decisão: **medalhas primeiro**. A medalha é
 * o resumo — doze itens, uma ou duas fileiras — e a coleção é o detalhe, com dezenas
 * de cartas e rolagem própria. Resumo antes de detalhe, e o mais leve primeiro para
 * a página ter algo desenhado enquanto as imagens da coleção chegam.
 *
 * O `id` entra em `aria-controls` e no `id` do DOM, então precisa ser único e estável
 * — trocá-lo não quebra nada visível, mas invalida o estado de recolhido de quem
 * estiver com a página aberta.
 */
export const TIPOS_DE_CONQUISTA = [
  {
    id: "medalhas",
    titulo: "Minhas medalhas",
    descricao: "Conquistadas pela sua constância e pelo XP que você acumulou",
    Icone: RiMedal2Fill,
    Conteudo: Medalhas
  },
  {
    id: "cartas",
    titulo: "Minhas cartas",
    descricao: "O álbum das trilhas — uma coleção por região do Brasil",
    Icone: RiCollageFill,
    Conteudo: ColecaoDeCartasDoAluno
  }
];

export default TIPOS_DE_CONQUISTA;
